export type StatKey =
  | 'vida'
  | 'vidaMax'
  | 'mana'
  | 'manaMax'
  | 'empatia'
  | 'valentia'
  | 'astucia'
  | 'resistencia'
  | 'vinculo';

export type Stats = Record<StatKey, number>;

export interface InventoryItem {
  id: string;
  nombre: string;
  descripcion: string;
  tipo: 'narrativo' | 'consumible' | 'equipo';
  cantidad: number;
  /** Si es consumible, efectos que aplica al usarse. */
  efectos?: Array<{ stat: StatKey; delta: number }>;
}

export interface Character {
  nombre: string;
  nivel: number;
  xp: number;
  xpParaSiguienteNivel: number;
  puntosSkillDisponibles: number;
  stats: Stats;
  skillsDesbloqueadas: string[];
  hechizosAprendidos: string[];
  inventario: InventoryItem[];
}

export const STATS_INICIALES: Stats = {
  vida: 50,
  vidaMax: 50,
  mana: 20,
  manaMax: 20,
  empatia: 1,
  valentia: 1,
  astucia: 1,
  resistencia: 1,
  vinculo: 3,
};

export function crearPersonajeInicial(nombre = 'Franco G.'): Character {
  return {
    nombre,
    nivel: 1,
    xp: 0,
    xpParaSiguienteNivel: 100,
    puntosSkillDisponibles: 0,
    stats: { ...STATS_INICIALES },
    skillsDesbloqueadas: [],
    hechizosAprendidos: [],
    inventario: [],
  };
}
